import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { groupQueries } from '@/services/groupsManagement/groupsManagement.queries';
import { GroupSummaryData } from '@/services/groupsManagement/groupsManagement.types';

export const useGroupSummary = () => {
  const { data, isLoading, error, isFetched } = useQuery({
    ...groupQueries.summary(),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });

  return {
    summary: data?.data || ({} as GroupSummaryData),
    isLoading,
    error,
    isFetched,
  };
};
